module.exports = __webpack_public_path__ + "static/media/style.29d248b7.scss";


//////////////////
// WEBPACK FOOTER
// ./src/views/pages/style.scss
// module id = 658
// module chunks = 0